import React from "react";
import { getPrerenderedMarketingPageHtml } from "./marketingSiteRoutes";

// Shown while a marketing chunk downloads. When the page was served as build-time static HTML, that same
// markup stays on screen (it is our own generated content, so rendering it as HTML is safe); otherwise the
// page keeps the marketing background instead of flashing the app's loader.
export function MarketingSiteLoadingFallback() {
  const prerenderedMarketingPageHtml = getPrerenderedMarketingPageHtml();
  if (prerenderedMarketingPageHtml) {
    return <div dangerouslySetInnerHTML={{ __html: prerenderedMarketingPageHtml }} />;
  }
  return <main className="marketing-page" aria-busy="true" />;
}
